import React from "react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import OrganizationService from "../../../services/OrderingServices/OrganizationService";

import { useState } from "react";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import toast from "react-hot-toast";

const DataSeed = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  const handleDataSeed = async () => {
    setLoading(true);
    try {
      const response = await OrganizationService.dataSeed();
      toast.success("Data seeding completed successfully.");
      toggle();
    } catch (error) {
      toast.error(
        error?.response?.data || "Data seeding failed. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Data Seed" pageTitle="Settings" />
      </div>

      <Row>
        <Col lg={12}>
          <Card>
            <CardHeader>
              <h4 className="card-title mb-0">Organization Data Seeding</h4>
            </CardHeader>
            <CardBody>
              <div className="live-preview">
                <p>
                  Data seeding initializes your organization with the required
                  default data, configurations, and system records needed for
                  proper application functionality.
                </p>

                <p>This process may include:</p>
                <ul>
                  <li>Creating default roles and permissions</li>
                  <li>Setting up baseline configurations</li>
                  <li>Adding system-required master data</li>
                  <li>Populating initial reference datasets</li>
                </ul>

                <p>
                  This operation is typically performed during initial setup or
                  when resetting system data.
                </p>

                <div
                  style={{
                    background: "#fff3cd",
                    padding: "12px",
                    borderRadius: "5px",
                    marginBottom: "15px",
                  }}
                >
                  <strong>⚠️ Important:</strong>
                  <ul style={{ marginBottom: 0 }}>
                    <li>Existing data may be overwritten or duplicated</li>
                    <li>Ensure a recent database backup is available</li>
                    <li>Avoid running this during active system usage</li>
                  </ul>
                </div>

                <Button color="primary" onClick={toggle}>
                  Run Data Seed
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* Simple Confirmation Modal */}
      <Modal isOpen={isOpen} toggle={toggle} centered>
        <ModalHeader toggle={toggle}>Confirm Action</ModalHeader>
        <ModalBody>
          Are you sure you want to proceed with data seeding?
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={toggle} disabled={loading}>
            Cancel
          </Button>
          <Button color="success" onClick={handleDataSeed} disabled={loading}>
            {loading ? "Processing..." : "Yes, Proceed"}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default DataSeed;
